// import React, { useEffect, useState } from 'react';
// import { Button, NewTable } from '../../../../components';
// import { allBillsrowdata } from '../../../../assets/data/candidatesData';
// import { mapTableRows } from '../../../../utils';
// import Checkbox from '../../../../components/FormFields/Checkbox';

// const DraftBills = () => {
//   const tablerowData = allBillsrowdata;

//   const DraftColumns = [

//     {
//       key: "InvoiceNumber",
//       label: "Invoice Number",
//       render: (row) => (
//         <span
//           className="cursor-pointer text-linkblue"
//           onClick={() => console.log(row)}
//         >{row.InvoiceNumber}
//         </span>
//       ),
//     },
//     { key: "Employees", label: "Employees" },
//     { key: "Vendor", label: "Vendor" },
//     { key: "VendorID", label: "Vendor ID" },
//     { key: "InvoiceDate", label: "Invoice Date" },
//     { key: "InvoiceDueDate", label: "Invoice Due Date" },
//     { key: "BillAmount", label: "Bill Amount" },
//     { key: "PaidAmount", label: "Paid Amount" },
//     { key: "DiscountAmount", label: "Discount Amount" },
//     { key: "DueAmount", label: "Due Amount" },
//     { key: "CreatedOn", label: "Created On" },
//        {
//       key: "actions",
//       label: "Actions",
//       render: (row) => (
//         <div className="flex items-center gap-2">
//           <Button
//             type="icon"
//             icon="download"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}
//           />
//           <Button
//             type="icon"
//             icon="edit_square"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}
//           />
//           <Button
//             type="icon"
//             icon="delete"
//             size="xs"
//             variant="text"
//             color="black"
//             onClick={""}

//           />
//         </div>
//       ),
//     },
//   ];

//   const mappedRows = mapTableRows(tablerowData, DraftColumns);

//   return (
//     <div>
//       <NewTable

//         columns={DraftColumns}
//         rows={mappedRows}
//         toolbarRight={[
//           { filterButton: false },
//           { DropdownMenu: false },
//         ]}
//       />
//     </div>
//   );
// };

// export default DraftBills;

import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  LogoLoader,
  Modal,
  NewTable,
  StatusTags,
} from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { useSelector, useDispatch } from "react-redux";
import { getAccountPayablesStart } from "../../../../redux/slices/accountPayables/accountPayablesSlice";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { usePagination } from "../../../../hooks";
import { Link, useNavigate } from "react-router-dom";
import { getVendorId } from "../../../../utils/getClientId";
import { formatCurrency } from "../../../../utils/stringUtils";
import ApInvoiceDetails from "../Modals/ApInvoiceDetails";

const DraftBills = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });

  const { loading, error, accountPayables } = useSelector(
    (state) => state.accountPayables,
  );

  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.accountpayables?.data;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );

  const tablerowData = accountPayables?.data || [];

  const handleSort = (field) => {
    setSortConfig((prevSort) => ({
      field,
      direction: prevSort.field === field ? -prevSort.direction : -1,
    }));
  };

  const DraftColumns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      render: (row) => (
        <div className="flex items-center gap-1">
          {/* <Link
            to={`/accounts-payable/edit/${row.uiid}`}
            state={{ code: row.uiid, edit: true }}
          > */}
          <span
            className="text-linkblue"
            onClick={() => setSelectedInvoice(row?.uiid)}
          >
            {row.invoiceNum}
          </span>
          {/* </Link> */}
        </div>
      ),
    },
    {
      key: "employeeId",
      label: "Employees",
      render: (row) => (
        <div>
          {row.employeeId.map((item, index) => (
            <span key={index}>
              {[item.firstName, item.lastName].filter(Boolean).join(" ")}
              {index < row.employeeId.length - 1 && ", "}
            </span>
          ))}
        </div>
      ),
    },
    {
      key: "vendorId",
      label: "Vendor",
      render: (row) => <div>{row.vendorId.businessName || "-"}</div>,
    },
    {
      key: "VendorID",
      label: "Vendor ID",
      render: (row) => <div>{getVendorId(row.vendorId.uiid)}</div>,
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "billedAmount",
      label: "Bill Amount",
      render: (row) => formatCurrency(row.amounts.billed),
    },
    {
      key: "paidAmount",
      label: "Paid Amount",
      render: (row) => formatCurrency(row.amounts.paid),
    },
    {
      key: "discountAmount",
      label: "Discount Amount",
      render: (row) => formatCurrency(row.amounts.discount),
    },
    {
      key: "dueAmount",
      label: "Due Amount",
      render: (row) => formatCurrency(row.amounts.due),
    },
    {
      key: "addedOn",
      label: "Created On",
      render: (row) => dateFormator(row.addedOn, "month-day-year"),
    },
    {
      key: "Actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            icon="download"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={() => navigate(`/accounts-payable/edit/${row.uiid}`)}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tablerowData, DraftColumns);

  useEffect(() => {
    dispatch(
      getAccountPayablesStart({
        limit,
        page,
        filters: {
          status: {
            type: "NONE",
            value: 1,
          },
        },
        ref: "Employee Vendor",
        incl: ["firstName lastName", "businessName"],
        sort: { [sortConfig.field]: sortConfig.direction },
      }),
    );
    dispatch(
      totalCountStart({
        filters: {
          status: {
            type: "NONE",
            value: 1,
          },
        },
        collection: "accountpayables",
        coll: "AccountPayable",
      }),
    );
  }, [dispatch, page, limit, sortConfig]);

  return (
    <div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <NewTable
        showCheckbox
        columns={DraftColumns}
        rows={mappedRows}
        toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        serverPagination={true}
        totalCount={totalCount}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
      />
      <Modal
        isOpen={selectedInvoice}
        title={"AP Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
        zIndex={56}
      >
        <ApInvoiceDetails
          invoiceUiid={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={false}
        />
      </Modal>
    </div>
  );
};

export default DraftBills;
